// extracted by mini-css-extract-plugin
export default {"XS":"0","xs":"0","SM":"450px","sm":"450px","MD":"768px","md":"768px","LG":"1024px","lg":"1024px","XL":"1250px","xl":"1250px"};